/**
 * One SLA presentation shared by the investor tracker and the ops queue, so "2d left" never
 * means something different depending on which app you are looking at.
 *
 * Returns null when the request is not in a phase with a deadline — the caller renders nothing
 * rather than a misleading zero.
 */
export default function unitTransferSlaToBadge(
  slaDaysRemaining?: number | null
): { label: string; color: string } | null {
  if (slaDaysRemaining === undefined || slaDaysRemaining === null) return null;

  if (slaDaysRemaining < 0) {
    const daysOverdue = Math.abs(slaDaysRemaining);
    return { label: `${daysOverdue}d overdue`, color: 'red' };
  }

  if (slaDaysRemaining <= 2) return { label: `${slaDaysRemaining}d left`, color: 'amber' };

  return { label: `${slaDaysRemaining}d left`, color: 'gray' };
}
